import instanceQuery from 'graphql/queries/supplier/PurchaseCreditPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const PurchaseCreditPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default PurchaseCreditPostingPreview;
